import { ApiUrl } from "common/services";
export const QuoteSelectionsUri = (uid: string) => `${ApiUrl}/quote/${uid}/selections`;
export const MuleNestingApiUri = `${ApiUrl}/mule/nesting`;
export const NestingApiUri = `${ApiUrl}/nesting`;
export const NestedQuoteUri = (uid: string) => `${ApiUrl}/quote/nested/${uid}`;
export const RequestDateUri = `${ApiUrl}/file/request_date`;
export const ItemOptionsUri = (uid: string) => `${ApiUrl}/file/item_options/${uid}`;
export const ContactSalesRep = "Contact Sales Representative";
export const TemplateDownloadUrl = `${ApiUrl}/file/download_gerdau_template`;
